import { TableTranslations } from '@/assets/locales/components/table/table.translations.en';

export const tableTranslations: TableTranslations = {
  content: {
    actionOnSelected: {
      actionOnSelected: 'Akcja na zaznaczonych',
      archive: 'Archiwizuj',
      delete: 'Usuń',
      duplicate: 'Duplikuj',
    },
    button: {
      resetForm: 'Resetuj',
      submitSearch: 'Szukaj',
    },
    maxRows: 'Maksymalna liczba wierszy',
    nextPage: 'Następna strona',
    noResults: 'Brak wyników',
    of: 'z',
    previousPage: 'Poprzednia strona',
  },
};
